/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateContactListResponseData,
  CreateContactListResponseDataFromJSON,
  CreateContactListResponseDataFromJSONTyped,
  CreateContactListResponseDataToJSON
} from './CreateContactListResponseData'

/**
 *
 * @export
 * @interface RemoveContactListResponse
 */
export interface RemoveContactListResponse {
  /**
   *
   * @type {number}
   * @memberof RemoveContactListResponse
   */
  status?: number
  /**
   *
   * @type {CreateContactListResponseData}
   * @memberof RemoveContactListResponse
   */
  data?: CreateContactListResponseData
}

export function RemoveContactListResponseFromJSON(json: any): RemoveContactListResponse {
  return RemoveContactListResponseFromJSONTyped(json, false)
}

export function RemoveContactListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RemoveContactListResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateContactListResponseDataFromJSON(json['data'])
  }
}

export function RemoveContactListResponseToJSON(value?: RemoveContactListResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateContactListResponseDataToJSON(value.data)
  }
}
